import type { OrganisationMember } from '@dreamai/types';
import { formatMinor } from './organisationCreditLabels';

/** "Fri 30 Oct 2026" */
export function formatPaymentDate(iso: string): string {
  return new Date(iso)
    .toLocaleDateString('en-GB', {
      weekday: 'short',
      day: 'numeric',
      month: 'short',
      year: 'numeric',
    })
    .replace(/,/g, '');
}

/** "£30/month" */
export function formatMonthly(amountMinor: number, currency: string): string {
  return `${formatMinor(amountMinor, currency)}/month`;
}

/** Members whose Personal Assistant the subscription pays for */
export function seatMembers(
  members: OrganisationMember[],
): OrganisationMember[] {
  return members.filter(
    (m) => m.status === 'active' && m.seatKind === 'assistant',
  );
}
